module.exports = require('./dist/nextra-theme-blog')
